export const styles = {
  input: {
    my: 1,
  },
  button: {
    my: 3,
  },
};
